import { AnnotationToolLayoutProps } from 'packages/at-shell/components/app-shell/app-layout';
import { ProfileMenuButton } from 'packages/polaris/profile-menu-button';
import { PolarisSider } from 'packages/polaris/portal/sider';

export default {
  theme: 'dark',
  sceneActions: (
    <>
      <ProfileMenuButton enableThemeToggle />
    </>
  ),
  sider: null,
  siderFooterActions: null,
  toolbar: <PolarisSider />,
  config: {
    toolbarProps: {
      width: 200,
    },
  },
} as Partial<AnnotationToolLayoutProps>;
